import React, { Fragment } from 'react';
import Navbar3 from '../../components/Navbar3/Navbar3';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import WelcomeSection from '../../components/WelcomeSection/WelcomeSection';
import WebSolutionsSection from '../../components/WebSolutionsSection/WebSolutionsSection';
import UserExperienceSection from '../../components/UserExperienceSection/UserExperienceSection';
import WebDevelopmentServices from '../../components/WebDevelopmentServices/WebDevelopmentServices';
import WebSoftwareFeatures from '../../components/WebSoftwareFeatures/WebSoftwareFeatures';

const webSolutionsData = [
    {
      title: "Web Portals",
      description: "We create customized web portals that serve as a central hub for your users, offering a seamless experience for accessing information, applications, and services.",
      image: "/img/web/web-1.jpeg",
      bgColor: "#ffab91",
    },
    {
      title: "Websites",
      description: "Our websites are visually appealing, user-friendly, and tailored to your brand. They are designed to engage visitors effectively, leaving a lasting impression.",
      image: "/img/web/web-2.jpeg",
      bgColor: "#80cbc4",
    },
    {
      title: "Ecommerce",
      description: "Ecommerce empower you to sell products or services online, with secure payment processing, inventory management, & an intuitive shopping experience for your customers.",
      image: "/img/web/web-3.jpeg",
      bgColor: "#ce93d8",
    },
    {
      title: "Web/Mobile Apps",
      description: "We develop applications that provide specific functionalities or services. These apps are accessible through web browsers and are designed to be responsive and easy to use.",
      image: "/img/web/web-4.jpeg",
      bgColor: "#fbc02d",
    },
    {
      title: "UI/UX Designs",
      description: "Our UI/UX design ensures exceptional user experiences with user-friendly, engaging interfaces that captivate your audience while enhancing digital solutions & fixing user problems.",
      image: "/img/web/web-5.jpeg",
      bgColor: "#b39ddb",
    },
  ];
  
  const headingText = "At Europa Solutions, we are a leading Website Development Company delivering professional web design services that help businesses grow in the digital world. Our WebCraft team specializes in creating responsive, SEO-friendly, and custom websites that not only look stunning but also perform exceptionally well.";
  
  const heading = "Web Solutions"

const ServicePage = () => {
    return (
        <Fragment>
          <div 
           style={{
            backgroundImage: `url('/img/webbg.jpeg')`,
            backgroundSize: 'cover', 
            backgroundPosition: 'center', 
            backgroundAttachment: 'fixed',
            position: 'relative', 
          }}
          >
            <Navbar3 topbarNone={'wpo-header-style-6'}/>
            <PageTitle pageTitle={'Enhance Your Digital Presence with WebCraft'} pageSub={'Professional Website Development and Management to Unlock Your Online Potential'} backgroundImage={require('../../images/web.jpeg')} />
             <WebSolutionsSection headingText={headingText} webSolutions={webSolutionsData} heading={heading}/>
            <UserExperienceSection />
            <WebSoftwareFeatures/>
            <WebDevelopmentServices/>
            <WelcomeSection title="Ready to embark on this journey?"
                subtitle="Whether you seek design, development, support, or technical consultation for your web solution, our comprehensive expertise is at your disposal. Simply complete our request form, and let us begin."
                buttonText="Contact Us" />
            </div>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default ServicePage;

